/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable camelcase */
import { Button, Dialog, IconButton } from '@mui/material'
import { useState } from 'react'
import ViewColumnIcon from '@mui/icons-material/ViewColumn'
import useStyles from './styles'
import IOSSwitch from '../../../components/Form/IOSSwitch'

const ColumnVisibility = ({ columns = [], additionalColumns = [], onChange }) => {
  const classes = useStyles()

  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const onChangeHandler = (i, value) => {
    onChange(
      columns.map((item, index) => {
        if (i === index) {
          return {
            ...item,
            value,
          }
        }
        return item
      })
    )
  }

  const bulkChange = (value) => {
    onChange(columns.map((item) => ({ ...item, value: item.disabled ? item.value : value })))
  }

  const checkAdditionalColumns = (col) => {
    if (col.key === 'error') {
      const exist = additionalColumns.includes('errors')

      return {
        disabled: exist ? col.disabled : true,
        checked: exist ? col.value : false,
      }
    }

    if (col.key === 'activeCount') {
      const exist = additionalColumns.includes('activeProducts')

      return {
        disabled: exist ? col.disabled : true,
        checked: exist ? col.value : false,
      }
    }

    // Always available on front
    // if (col.key === 'averageOrganicRank') {
    //   const exist = additionalColumns.includes('averageOrganicRank')

    //   return {
    //     disabled: exist ? col.disabled : true,
    //     checked: exist ? col.value : false,
    //   }
    // }

    return {
      disabled: col.disabled,
      checked: col.value,
    }
  }

  const open = Boolean(anchorEl)

  return (
    <div className={classes.hide_col_btn}>
      <IconButton aria-label="Show/Hide columns" className="hide-col-btn" onClick={handleClick}>
        <ViewColumnIcon />
      </IconButton>
      <Dialog onClose={handleClose} open={open}>
        <div className={classes.popover}>
          <div className={classes.popover_header}>
            <Button variant="text" onClick={() => bulkChange(false)}>
              Hide All
            </Button>
            <Button variant="text" onClick={() => bulkChange(true)}>
              Show All
            </Button>
          </div>
          <div className={classes.popover_list}>
            {columns.map((item, index) => {
              if (
                (item.key === 'error' && !additionalColumns.includes('errors')) ||
                (item.key === 'activeCount' && !additionalColumns.includes('activeProducts'))
                // Always available on front
                // || (item.key === 'averageOrganicRank' && !additionalColumns.includes('averageOrganicRank'))
              ) {
                return null
              }

              return (
                <div className={classes.popover_list_item} key={item.key}>
                  <div>{item.label}</div>
                  <div>
                    <IOSSwitch
                      checked={checkAdditionalColumns(item).checked}
                      disabled={checkAdditionalColumns(item).disabled}
                      onChange={(e) => {
                        onChangeHandler(index, e.target.checked)
                      }}
                    />
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </Dialog>
    </div>
  )
}
export default ColumnVisibility
